var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchitecture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#233C85",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M470,0H20C8.972,0,0,8.972,0,20v450c0,11.028,8.972,20,20,20h450c11.028,0,20-8.972,20-20V20C490,8.972,481.028,0,470,0z M470,470H20V90h450V470z M470,70H20V20h450V70z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 35,
    width: 35,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 35,
    width: 35,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 35,
    width: 35,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,300.001h17.192c1.003,2.733,2.089,5.382,3.254,7.94l-12.117,12.188c-3.775,3.775-5.854,8.79-5.854,14.122 c0,5.332,2.08,10.347,5.854,14.121l28.299,28.299c3.775,3.775,8.79,5.854,14.122,5.854c5.332,0,10.347-2.079,14.101-5.833 l12.209-12.138c2.557,1.164,5.207,2.25,7.94,3.253V385c0,11.028,8.972,20,20,20h40c11.028,0,20-8.972,20.001-20v-17.193 c2.733-1.003,5.382-2.089,7.94-3.254l12.188,12.117c3.775,3.775,8.79,5.854,14.122,5.854c5.332,0,10.347-2.08,14.121-5.854 l28.299-28.299c3.775-3.775,5.854-8.79,5.854-14.122c0-5.332-2.079-10.347-5.833-14.101l-12.138-12.209 c1.164-2.557,2.25-5.207,3.253-7.94H370c11.028,0,20-8.972,20-20v-40c0-11.028-8.972-20-20-20h-17.193 c-1.003-2.733-2.089-5.382-3.254-7.94l12.117-12.188c3.775-3.775,5.854-8.79,5.854-14.122c0-5.332-2.08-10.347-5.854-14.121 l-28.299-28.299c-3.775-3.775-8.79-5.854-14.122-5.854c-5.332,0-10.347,2.079-14.101,5.833l-12.209,12.138 c-2.557-1.164-5.207-2.25-7.94-3.253V135c0-11.028-8.972-20-20-20h-40c-11.028,0-20,8.972-20,20v17.193 c-2.733,1.003-5.382,2.089-7.94,3.254l-12.188-12.117c-3.775-3.775-8.79-5.854-14.122-5.854c-5.332,0-10.347,2.08-14.121,5.854 l-28.299,28.299c-3.775,3.775-5.854,8.79-5.854,14.122c0,5.332,2.079,10.347,5.833,14.101l12.138,12.209 c-1.164,2.557-2.25,5.207-3.253,7.94H120c-11.028,0-20,8.972-20,20v40C100,291.029,108.972,300.001,120,300.001z M120,239.999 h24.402c4.416,0,8.309-2.897,9.578-7.127c1.973-6.575,4.459-12.62,7.39-17.966c2.132-3.887,1.449-8.713-1.677-11.858 l-17.22-17.277l28.277-28.279l17.3,17.199c3.144,3.126,7.97,3.807,11.858,1.677c5.346-2.931,11.391-5.417,17.966-7.39 c4.231-1.268,7.127-5.162,7.127-9.578V135h40v24.402c0,4.416,2.897,8.309,7.127,9.578c6.575,1.973,12.62,4.459,17.966,7.39 c3.887,2.132,8.712,1.45,11.858-1.677l17.277-17.22l28.279,28.277l-17.199,17.3c-3.126,3.144-3.809,7.97-1.677,11.858 c2.931,5.346,5.417,11.391,7.39,17.966c1.268,4.231,5.162,7.127,9.578,7.127H370v40h-24.4c-4.416,0-8.309,2.897-9.578,7.127 c-1.973,6.575-4.459,12.62-7.39,17.966c-2.132,3.887-1.449,8.713,1.677,11.858l17.22,17.277l-28.277,28.279l-17.3-17.199 c-3.146-3.126-7.971-3.809-11.858-1.677c-5.346,2.931-11.391,5.417-17.966,7.39c-4.231,1.268-7.127,5.162-7.127,9.578V385h-40 v-24.401c0-4.416-2.897-8.309-7.127-9.578c-6.575-1.973-12.62-4.459-17.966-7.39c-1.511-0.828-3.164-1.231-4.805-1.231 c-2.581,0-5.131,0.997-7.055,2.907l-17.277,17.22l-28.279-28.277l17.199-17.3c3.126-3.144,3.809-7.97,1.677-11.858 c-2.931-5.346-5.417-11.391-7.39-17.966c-1.268-4.231-5.162-7.127-9.578-7.127H120V239.999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,310c27.57,0,50-22.43,50-50s-22.43-50-50-50s-50,22.43-50,50S217.43,310,245,310z M245,230 c16.542,0,30,13.458,30,30s-13.458,30-30,30s-30-13.458-30-30S228.458,230,245,230z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 150,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 150,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 150,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 350,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 350,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 350,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 430,
    width: 360,
    height: 20
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitecture);
export default __webpack_public_path__ + "static/media/architecture.362372d0cba6adfc98f26660028944e9.svg";
export { ForwardRef as ReactComponent };